import React from 'react';

export default function ErrorBox({ message = 'Something went wrong.' }) {
  return (
    <div className="rounded-md bg-red-50 p-4">
      <p className="text-sm font-medium text-red-800">{message}</p>
    </div>
  );
}
